import React, { useState } from 'react';
import '../styles/Leadership.css';

const Leadership = () => {
  const [activeBio, setActiveBio] = useState(null);

  const leaders = [
    {
      id: 1,
      name: "Leighton Jacobus",
      title: "Founder & Chief Cause-Centric, High-Impact Officer",
      shortBio: "A multifaceted leader who combines fiscal sponsorship expertise with nonprofit innovation and a passion for horticulture.",
      fullBio: "Leighton's journey is anything but conventional. From building successful businesses to pursuing medical school and getting published in botany, he's always followed his curiosity. As a recognized expert in fiscal sponsorship, he's helped scale some of the nation's largest fiscal sponsoring organizations before founding Cause & Impact. When he's not revolutionizing nonprofit operations, you'll find him tending to his extensive plant collection or hiking with his three dogs - a German Shepherd and two German Shorthaired Pointers. His unique blend of business acumen, scientific background, and genuine passion for helping others makes him the driving force behind our organization's innovative approach to fiscal sponsorship.",
      image: "/assets/staffimages/Leighton-Jacobus-Staffimage.png",
      expertise: ["Fiscal Sponsorship", "Nonprofit Growth", "Compliance", "Operations", "Botanical Research"],
      linkedin: "https://linkedin.com/in/leightonjacobus"
    },
    
    {
      id: 3,
      name: "Simon Izaguirre, MD",
      title: "Director & Board Certified Vascular Neurologist",
      shortBio: "A renaissance man combining medical innovation with engineering passion.",
      fullBio: "Dr. Simon isn't your typical neurologist. When he's not developing cutting-edge approaches to stroke treatment, you might find him in his garage engineering race car parts or crafting his latest home-brewed beer recipe. His innovative spirit extends from the medical field to the mountains of Colorado, where he's an avid hiker. Simon and Leighton's friendship began in medical school, where they discovered their shared passion for pushing boundaries and thinking differently. This led to Simon becoming one of our founding directors, bringing his unique perspective to our mission and a pursuit of excellence. His ability to excel in everything from neurology to engineering embodies our organization's belief that the best solutions come from thinking beyond traditional boundaries.",
      image: "/assets/staffimages/SimonIzaguirreTeamPhoto.png",
      expertise: ["Vascular Neurology", "Medical Innovation", "Engineering", "Stroke Prevention", "Leadership"],
      linkedin: "https://linkedin.com/in/simonizaguirre"
    },
    {
      id: 4,
      name: "Kirsty Zapatka",
      title: "Director, Treasurer",
      shortBio: "A financial strategist who makes nonprofit accounting both transparent and transformative.",
      fullBio: "Kirsty brings clarity and innovation to the complex world of nonprofit finance. As our CPA and Treasurer, she ensures our financial operations are not just compliant, but strategic and forward-thinking. Her approach to nonprofit accounting goes beyond numbers – it's about creating sustainable impact through smart financial management. With her expertise, we're transforming how organizations think about their financial health while maintaining the highest standards of fiscal responsibility and transparency.",
      image: "/assets/staffimages/Kirsty-Zapatka-Staffimage.png",
      expertise: ["Nonprofit Accounting", "Financial Strategy", "Tax Compliance", "Treasury Management", "Risk Assessment"],
      linkedin: "https://linkedin.com/in/kirstyzapatka"
    },
    {
      id: 5,
      name: "PHIL",
      title: "AI Compliance Expert",
      shortBio: "Phil is your AI-powered compliance guide—helping nonprofits and fiscally sponsored projects navigate IRS rules, grant requirements, and nonprofit regulations with clarity and confidence. Smart, approachable, and always ready to help—just ask Phil.",
      fullBio: "Phil isn’t just any chatbot—he’s the first AI built specifically to help nonprofits and fiscally sponsored projects navigate compliance with confidence. Developed by SponsFI and assigned to Cause & Impact, Inc., Phil serves as the first line of support for nonprofit leaders, fiscal sponsors, and project managers who need clear, reliable guidance on nonprofit operations and IRS regulations. As a Proactive Helper for IRS & Legal Compliance (P.H.I.L.), he’s more than just a virtual assistant—he’s an on-demand compliance guide, best-practice resource, and fiscal sponsorship expert, all in one. While Phil isn’t a lawyer or CPA, he is trained extensively in 501(c)(3) compliance, fiscal sponsorship best practices, nonprofit governance, donor stewardship, and state and federal nonprofit regulations. His knowledge extends beyond industry standards—he’s also fluent in Cause & Impact’s specific policies, services, and FAQs, making him an invaluable resource for the organizations we support. Phil doesn’t just answer compliance questions—he can review vendor contracts related to nonprofit work, analyze grant RFPs, and help interpret any document that requires compliance oversight. Whether you need to confirm if an agreement aligns with nonprofit best practices, check if an expense qualifies as charitable, or ensure you’re meeting grant reporting requirements, Phil is ready to guide you through it all. Phil is available 24/7 to answer questions, provide best-practice guidance, and help organizations stay compliant, avoid mistakes, and focus on their mission. Whether you need to know if an expense qualifies as charitable, how to properly report income, or how to manage a fiscally sponsored project, Phil is your personal compliance assistant—always ready to help. Navigating nonprofit compliance starts with one question: ‘Hey Phil…’",
      image: "/assets/staffimages/PHIL-Staffimage.png",
      expertise: ["AI Compliance Expert", "Nonprofit Guidance", "Fiscal Sponsorship Assistant", "Treasury Management", "Risk Assessment"],
    
    }
  ];

  return (
    <div className="leadership-wrapper">
      <div className="leadership-container">
        <div className="leadership-header">
          <h1>Passion behind the Cause</h1>
          <p>Innovators at the intersection of technology and philanthropy, guiding our mission to modernize fiscal sponsorship</p>
        </div>

        <div className="leaders-grid">
          {leaders.map((leader) => (
            <div 
              key={leader.id}
              className={`leader-card ${activeBio === leader.id ? 'active' : ''}`}
              onClick={() => setActiveBio(activeBio === leader.id ? null : leader.id)}
            >
              <div className="leader-image">
                <img src={leader.image} alt={leader.name} />
                <div className="leader-overlay">
                  <span>Click to learn more</span>
                </div>
              </div>
              
              <div className="leader-info">
                <h2>{leader.name}</h2>
                <h3>{leader.title}</h3>
                <p>{activeBio === leader.id ? leader.fullBio : leader.shortBio}</p>
                
                {activeBio === leader.id && (
                  <div className="leader-details">
                    <div className="expertise-tags">
                      {leader.expertise.map((skill, index) => (
                        <span key={index} className="expertise-tag">{skill}</span>
                      ))}
                    </div>
                    <a 
                      href={leader.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="linkedin-link"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Connect on LinkedIn
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Leadership; 